const expression: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g;

export const sanitizeString = (input: string): string => {
    if (input != null && input != "")
        return input.replaceAll(expression, "");
    else return input;
}